import request from '@/utils/request'
export default {
  getOriginChildTree (pid) {
    return request({
      url: '/api/system/area/list',
      method: 'Get',
      params: { pid }
    })
  },
  // 根据父级id和下级地区名称模糊查询
  getDqChild (areaname, pid) {
    return request({
      url: '/api/system/area/name-like/list',
      method: 'GET',
      params: { areaname, pid }
    })
  },
  // 根据父级id和代表名称模糊查询
  getDqPeople (dbName, areaId, pageIndex, pageSize) {
    return request({
      url: '/api/app/wechat/area-db/page',
      method: 'GET',
      params: { areaId, dbName, pageIndex, pageSize }
    })
  }
}
